export default __webpack_public_path__ + "static/open-devtools-ac73f80bd17b2f8f6c84e567d0b6eecc.mp4";